import { render, staticRenderFns } from "./TeacherStatus.vue?vue&type=template&id=bad001da"
import script from "./TeacherStatus.vue?vue&type=script&lang=js"
export * from "./TeacherStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bad001da')) {
      api.createRecord('bad001da', component.options)
    } else {
      api.reload('bad001da', component.options)
    }
    module.hot.accept("./TeacherStatus.vue?vue&type=template&id=bad001da", function () {
      api.rerender('bad001da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/TeacherStatus.vue"
export default component.exports